import { module } from 'angular';
import kpathComponent from './kpath.component';
import './kpath.scss';

export default module('app')
	.component('kpath', kpathComponent)
	.name;
